import React from "react";
import css from "../assets/css.png";
import github from "../assets/github.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import tailwind from "../assets/tailwind.png";
import mongodb from "../assets/mongodb.png";
import node from "../assets/nodejs.png";
import postman from "../assets/postman.png";
import redux from "../assets/reduxtoolkit.png";
import reactrouter from "../assets/reactrouter.png";
import git from "../assets/git.png";

const Experience = () => {
  const exp = [
    {
      id: 1,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 2,
      src: react,
      title: "React",
      style: "shadow-blue-600",
    },
    {
      id: 3,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 4,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400",
    },
    {
      id: 5,
      src: mongodb,
      title: "MongoDB",
      style: "shadow-green-400",
    },
    {
      id: 6,
      src: node,
      title: "Node",
      style: "shadow-green-600",
    },
    {
      id: 7,
      src: postman,
      title: "Post Man",
      style: "shadow-orange-600",
    },
    {
      id: 8,
      src: redux,
      title: "Redux Toolkit",
      style: "shadow-purple-600",
    },
    {
      id: 9,
      src: git,
      title: "Git",
      style: "shadow-orange-600",
    },
    {
      id: 10,
      src: reactrouter,
      title: "React Router",
      style: "shadow-red-400",
    },
    {
      id: 11,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 12,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
  ];

  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black
      w-full text-white"
    >
      <div
        className="flex flex-col justify-center w-full h-full
        max-w-screen-lg mx-auto"
      >
        <div>
          <p
            className="text-4xl font-bold inline border-b-4 
          border-gray-500"
          >
            Experience
          </p>
          <p className="py-6">
            These are the tools & technologies i have worked with
          </p>
        </div>

        <div
          className="w-full grid grid-cols-4 sm:grid-cols-4
        gap-8 text-center py-8 px-12 sm:px-0 cursor-pointer"
        >
          {exp.map(({ id, src, style, title }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-300 rounded-lg py-2 ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
